import { UntypedFormGroup } from '@angular/forms';

// custom validator to check that two fields match
export function MustMatchValidator(controlName: string, matchingControlName: string) {
    return (formGroup: UntypedFormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];

        if (matchingControl.errors && !matchingControl.hasError('mustMatch')) {
            // return if another validator has already found an error on the matchingControl
            return;
        }

        // set error on matchingControl if validation fails
        if (control.value !== matchingControl.value) {
            matchingControl.setErrors({ mustmatch: true });
        } else {
            matchingControl.setErrors(null);
        }
    }
}